import React, { useEffect, useState } from "react";
import { Button, message } from "antd";
import fourmstyle from "../../styles/fourm.module.scss";
import { authSVC } from "../../services";
import { useNavigate } from "react-router-dom";

export function AuthenticatorEnableDisable(
  props: React.PropsWithChildren<any>
): JSX.Element {
  const [showConfirm, setShowConfirm] = useState(false);
  const navigate = useNavigate();
  const factorAuthEnable = props.factorAuthEnable;
  console.log(`Props`, props);

  const handleCancel = () => {
    setShowConfirm(false);
    console.log(`Cancelled`);
  };

  const handleConfirm = () => {
    authSVC
      .toggle2FA({})
      .then((res: any) => {
        if (res.data.success === true) {
          message.success(res.data.message);
          console.log(`Toggle ${res}`);
          localStorage.setItem(
            "authenticatorEnable",
            res.data.two_factor_enabled
          );
          localStorage.setItem("showAuthenticatorQR", "false");
          if (factorAuthEnable == "true") {
          }
          setTimeout(() => {
            navigate(-1);
          }, 1500);
        } else {
          message.error(res.data.error);
        }
      })
      .catch((err) => {
        console.log(`Error : ${err.message}`);
        message.error(err.message);
      });
  };

  const toggle2FA = () => {
    setShowConfirm(true);
  };
  return (
    <>
      <Button
        className={fourmstyle.save_button}
        htmlType="button"
        onClick={toggle2FA}
      >
        {factorAuthEnable == "true" ? "Disable 2FA" : "Enable 2FA"}
      </Button>
      {showConfirm && (
        <div className="backdrop">
          <div className="dialog">
            <p>
              Are you sure you want to{" "}
              {factorAuthEnable == "true" ? "disable" : "enable"} 2FA?
            </p>
            <div className="button_set">
              <button onClick={handleConfirm}>Yes</button>
              <button onClick={handleCancel}>No</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
